// 1200 -> 12
const formatPrice = (priceInCents: number | null) => {
  return priceInCents ? priceInCents.toString().slice(0, -2) : ''
}

// $15.49 -> 1549
export const parsePriceDollarToCents = (
  priceInDollar?: string | null
): number | null => {
  return priceInDollar ? parseFloat(priceInDollar.slice(1)) * 100 : null
}

// 1549 -> 15.49, 1540 -> 15.40, 1500 -> 15
export const parsePriceCentsToDollar = (
  priceInCents?: number | null
): string | null => {
  if (!priceInCents) return null

  const isInteger = priceInCents % 100 === 0
  return isInteger
    ? parseFloat((priceInCents / 100).toString()).toFixed(0)
    : parseFloat((priceInCents / 100).toString()).toFixed(2)
}

export default formatPrice
